import { createApp } from 'vue'
import App from './App.vue'
import 'amfe-flexible'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus' //全局引入
import '@/utils/rem.js'
import 'element-plus/dist/index.css'
import VueLazyload from "vue-lazyload";
updateFavicon('favicon.ico');
function updateFavicon(iconName) {
    const favicon = document.getElementById('dynamic-favicon');
    if (favicon && iconName) {
      // 添加时间戳防止缓存
      const newHref = `${process.env.BASE_URL}${iconName}?t=${Date.now()}`;
      favicon.href = newHref;
    }
  }

createApp(App).use(store).use(router).use(ElementPlus).use(VueLazyload).mount('#app')
